// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"209":"fb59a8f1","807":"995ec853"}[chunkId] + ".chunk.css";
};